
function getMainDomain() {
  var parts = window.location.hostname.split('.');
  if (parts.length >= 2) {
    return parts.slice(parts.length - 2).join('.');
  } else {
    // Handle cases where the hostname is just one part (e.g., localhost)
    return window.location.hostname;
  }
}

const Cookie = {
  get: cname => {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return null;
  },
  set: (cname, cvalue, exdays) => {
    const domain = window.location.hostname;
    var dt = new Date();
    dt.setTime(dt.getTime() + (exdays || 36500) * 24 * 60 * 60 * 1000);
    const expires = `expires=${dt.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};domain=${domain};path=/; Secure`;
    // document.cookie =
    //   cname + "=" + cvalue + "; expires=" + dt.toUTCString() + "; path=/";
    return cvalue;
  },
  del: (cname) => {
    var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname;
      }
      let mainDmain = getMainDomain()
      document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + mainDmain;
      document.cookie = cname + "=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }
  // del: cname => {
  //   const domain = window.location.hostname;
  //   var dt = new Date();
  //   dt.setTime(dt.getTime() - 24 * 60 * 60 * 1000);
  //   const expires = `expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  //   document.cookie = `${cname}=0;${expires};domain=${domain};path=/; Secure`;
  //   document.cookie = cname + "=0; expires=" + dt.toUTCString() + "; path=/";
  //   return true;
  // }
};

export default Cookie;
